export default "__VITE_ASSET__BfsFE2yH__"